module.exports = __webpack_public_path__ + "img/cmps/Like/img/icon-unlike.6173d88d47547b74927b633f997f63f0.png";